( function( $ ) {
	// Used in single quiz pages
	// Checks if there are more than 20 active choices and then adds a class to wrap the children in columns
	const maxItems = parseInt( 20 );

	setTimeout( function() {
		$( '.wpProQuiz_listItem' ).each( function() {
			if ( $( this ).css( 'display' ) !== 'none' ) {
				const totalChildren = parseInt( $( this ).find( '.wpProQuiz_questionInput' ).length );
				if ( totalChildren >= maxItems ) {
					$( this ).find( '.wpProQuiz_questionList' ).addClass( 'wrap-children' );
				}
			}
		} );
	}, 100 );
}( jQuery ) );
